<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="_title">
          <v-icon small>
            mdi-text-box-search-outline
          </v-icon>
          SQL Viewer
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="card-wrap">
          <v-card-title>{{ this.$t('sql.title.ssr') }}</v-card-title>
          <div class="box">
            <table class="section" width="100%">
              <thead>
                <tr>
                  <th width="6%" class="text-left">{{ this.$t('sql.system') }}</th>
                  <th width="10%" class="text-left">{{ this.$t('sql.userId') }}</th>
                  <th width="14%" class="text-left">{{ this.$t('sql.begin') }}</th>
                  <th width="14%" class="text-left">{{ this.$t('sql.end') }}</th>
                  <th width="14%" class="text-left">Report</th>
                  <th width="14%" class="text-left">T-Code</th>
                  <th width="14%" class="text-left">Reference Program</th>
                  <th class="text-left">Internal Command</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><v-text-field :value="step.sstmId" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.account" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="format(step.starttimestamp, 'yyyy-MM-dd HH:mm:ss')" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="format(step.endtimestamp, 'yyyy-MM-dd HH:mm:ss')" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.report" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.tcode" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.cuaProg" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.cuaFunc" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="card-wrap">
          <v-card-title>{{ this.$t('sql.title.sqlList') }}</v-card-title>
          <div class="box">
            <v-data-table v-model="selectedSqls" :headers="headers" :items="sqls" item-key="sqlId" :loading="loading" @click:row="highlight" height="150" class="elevation-0 content" dense hide-default-footer single-select fixed-header>
              <template v-slot:item.sampleTime="{ value }">
                {{ format(value, 'yyyy-MM-dd HH:mm:ss') }}
              </template>
              <template v-slot:footer>
                <v-textarea :value="selectedSql.sqlFulltext" class="text-full-width" height="80" outlined dense hide-details readonly></v-textarea>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="card-wrap">
          <v-card-title>{{ this.$t('sql.title.bind') }}</v-card-title>
          <div class="box">
            <bind-variables :sql="selectedSql"></bind-variables>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="card-wrap">
          <v-card-title>{{ this.$t('sql.title.plan') }}</v-card-title>
          <div class="box">
            <execution-plan :sql="selectedSql"></execution-plan>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BindVariables from './BindVariables';
import ExecutionPlan from './ExecutionPlan';
import { api } from '../../../api/common/instances';
import { format } from 'date-fns';

export default {
  components: {
    BindVariables,
    ExecutionPlan,
  },
  data() {
    return {
      step: [],
      // step: {
      //   sdt: parseInt(this.$route.query.sdt),
      //   edt: parseInt(this.$route.query.edt),
      //   sid: this.$route.query.sid,
      //   acc: this.$route.query.acc,
      //   report: this.$route.query.report,
      //   tcode: this.$route.query.tcode,
      //   cuap: this.$route.query.cuap,
      //   cuaf: this.$route.query.cuaf,
      // },
      sqls: [],
      // 테이블이 single-select 이더라도 veutify의 data-table의 v-model은
      // 무조건 array를 원하므로 어쩔 수 없어 array를 사용해야 함.
      selectedSqls: [],
      selectedSql: {},
      params: {},
      loading: false,
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('sql.begin'), value: 'sampleTime', sortable: false, width: '15%' },
        { text: 'SQL ID.', value: 'sqlId', sortable: false, width: '15%' },
        { text: 'SQL Child No.', value: 'sqlChildNumber', sortable: false, width: '10%' },
        { text: this.$t('sql.sessionSerial'), value: 'sessionSerial', sortable: false, width: '10%' },
        { text: 'Module', value: 'module', sortable: false },
        { text: 'Action', value: 'action', sortable: false, width: '10%' },
      ];
    },
  },
  async created() {
    this.loading = true;
    ({ data: this.step } = await api.get('/analysis/sqlviewer/ssr', {
      params: {
        bgnYmdhms: parseInt(this.$route.query.bgn),
        sstmId: this.$route.query.sid,
        instId: this.$route.query.iid,
        seq: parseInt(this.$route.query.seq),
      },
    }));
    ({ data: this.sqls } = await api.get('/analysis/sqlviewer/ash-list', {
      params: {
        srchBgnYmdhms: this.step.starttimestamp,
        srchEndYmdhms: this.step.endtimestamp,
        sstmId: this.step.sstmId,
        clientId: this.step.account,
      },
    }));
    // 최초 로딩 시에는 첫번째 행이 선택 되도록...
    this.selectedSql = this.sqls[0];
    this.selectedSql.isSelected = true;
    this.selectedSqls.push(this.selectedSql);
    this.loading = false;
  },
  watch: {
    selectedSqls(value) {
      this.selectedSql = value[0];
    },
  },
  methods: {
    highlight(item, { isSelected, select }) {
      // 같은 row를 클릭했을 때는 선택이 풀리지 않도록 리턴...
      if (item.sqlId === this.selectedSql.sqlId) {
        return;
      }
      select(!isSelected);
    },
    format,
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 10px 10px 10px;
  margin: 0;
  max-width: 100%;
}
._title {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2;
}
.section th {
  padding: 0 0 3px 6px;
}
.section td {
  padding: 0 0 0 3px;
}
.text-full-width {
  width: auto;
}
</style>
